import { SearchInput } from '../shared';
import { SortOrder, TicketTypeSortType } from '../enums';

export class GetTicketTypesInput extends SearchInput<TicketTypeSortType> {
    constructor() {
        super(TicketTypeSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}